export default __webpack_public_path__ + "static/media/03__o_preview_0.f0857a8a.jpg";